import React from 'react';
import Purchase from 'modules/purchase/purchase';
import Header from 'modules/header/farm/main';

const PurchaseContainer = () => {
  return (
    <div className="flex w-full h-full flex-col">
      <Header title="ثبت آگهی خرید" />
      <div className="flex w-full justify-center">
        <div className="  w-[90%]   flex flex-col items-center gap-4 h-full py-4 justify-center">
          <Purchase />
        </div>
      </div>
    </div>
  );
};

export default PurchaseContainer;
